<template>
  <form @submit.prevent="validateAccount" class="form-group">
    <label>Téléphone</label>
    <input
      type="text"
      v-model="phone"
      :disabled="!!phoneFromUrl || loading"
      placeholder="Ex: 0600000000"
    />

    <label>Code de validation (6 caractères max)</label>
    <input
      type="text"
      v-model="validationCode"
      maxlength="6"
      :disabled="loading"
      placeholder="Entrez le code"
    />

    <div class="btn-group">
      <button
        type="submit"
        class="btn btn-primary"
        :disabled="loading"
        :aria-busy="loading"
      >
        <span v-if="loading" class="btn-loader">
          <span class="spinner" aria-hidden="true"></span>
          Validation...
        </span>
        <span v-else>Valider</span>
      </button>

      <router-link
        :to="{ name: 'resend' }"
        class="btn btn-secondary"
        :class="{ disabled: loading }"
        :aria-disabled="loading"
        @click.prevent="loading ? null : undefined"
      >
        Renvoyer le code
      </router-link>
    </div>
  </form>
</template>

<script setup>
import { config } from '@/config/env.js'
import { ref, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useToast } from 'vue-toast-notification'
import { storeToRefs } from 'pinia'
import { useLocaleStore } from '@/stores/localeStore'
import { useUserStore } from '@/stores/userStore'

const route = useRoute()
const router = useRouter()
const phone = ref('')
const validationCode = ref('')
const loading = ref(false)
const toast = useToast()
const localeStore = useLocaleStore()
const userStore = useUserStore()
const { countryIso } = storeToRefs(localeStore)

const phoneFromUrl = computed(() => route.params.phone)

onMounted(() => {
  if (phoneFromUrl.value) {
    phone.value = phoneFromUrl.value
  }
})

async function validateAccount() {
  if (loading.value) return

  if (validationCode.value.length !== 6) {
    toast.error('Le code de validation doit contenir 6 chiffres.')
    return
  }

  loading.value = true

  try {
    const response = await fetch(config.apiUrl + '/user/validate', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'include',
      body: JSON.stringify({
        phone: phone.value,
        verificationCode: validationCode.value,
        countryIso: countryIso.value
      })
    })

    if (!response.ok) {
      const data = await response.json()
      throw new Error(data.message || 'Erreur lors de la validation du compte')
    }

    await userStore.fetchUser()

    toast.success('Compte validé avec succès !')
    router.push({ name: 'account' })
  } catch (error) {
    toast.error(error.message)
  } finally {
    loading.value = false
  }
}
</script>
